<template>
  <div class="redis_manage_list">
    <div class="header">
      <el-row>
        <el-col :span="11">
          <el-button size="medium" type="danger" v-if="isShowByPermission('/wyms/redis/deleteZ')" @click="deleteSelectHandler">删除</el-button>
          <el-button size="medium" type="primary" v-if="deleteType === 2 && dataList.length && nextCursor !== '0'" @click="searchRedis(2, nextCursor)">下一页</el-button>
          <el-button size="medium" v-if="deleteType === 2 && dataList.length">执行时间：{{nextTime}}</el-button>
          <el-button size="medium" v-if="deleteType === 2 && dataList.length">扫描次数：{{nextCursor}}</el-button>
        </el-col>
        <el-col :span="13">
          <el-button size="medium" type="danger" class="header_right_btn" v-if="isShowByPermission('/wyms/redis/blurryDelete')" @click="blurryDelete">模糊删除</el-button>
          <el-button size="medium" type="primary" class="header_right_btn" v-if="isShowByPermission('/wyms/redis/indexScanZ')" @click="searchRedis(1)">精准搜索</el-button>
          <el-button size="medium" type="primary" class="header_right_btn" v-if="isShowByPermission('/wyms/redis/indexScanZ')" @click="searchRedis(2)">模糊搜索</el-button>
          <el-input size="medium" class="search-input search-input--right" v-if="isShowByPermission('/wyms/redis/indexScanZ')" placeholder="应用名称" v-model="searchName" @keyup.enter.native="searchRedis(2)"></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="redis_content">
      <el-table @select="selectionChangeHandler" @select-all="selectionChangeHandler" border :height="windowHeight - 160" :data="dataList" style="width: 100%">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column prop="title" label="key" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="key_name" @click="toRedisKeyInfo(scope.row)">{{scope.row}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isShowByPermission('/wyms/redis/deleteZ')" label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandler(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import {indexScan, redisDelete, blurryDelete} from '@/api/commonTool'

  export default {
    name: "redisManageList",
    data() {
      return {
        searchName: '',
        deleteType: 1,
        nextCursor: '',
        nextTime: 0,
        selectKeyList: [],
        dataList: []
      }
    },
    created() {
    },
    mixins: [windowResize],
    methods: {
        isShowByPermission,
      selectionChangeHandler(selection) {
        this.selectKeyList = selection;
      },
      toRedisKeyInfo(key) {
        this.$router.push({path: 'redisManageInfo', query: {key: key}})
      },
      blurryDelete() {
        this.$confirm("确认要删除吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          blurryDelete({key: this.searchName}).then(() => {
            this.$message.success('删除成功！');
            this.searchRedis(this.deleteType);
          })
        });
      },
      deleteHandler(id) {
        this.$confirm("确认要删除当前项吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          redisDelete({keyList: [id]}).then(() => {
            this.$message.success('删除成功！');
            this.searchRedis(this.deleteType);
          })
        });
      },
      deleteSelectHandler() {
        if (!this.selectKeyList.length) {
          this.$message.warning('请选择需要删除的key！');
          return;
        }
        this.$confirm("确认要删除所选项吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          redisDelete({keyList: this.selectKeyList}).then(() => {
            this.$message.success('删除成功！');
            this.searchRedis(this.deleteType);
          })
        });
      },
      searchRedis(type, cursor) {
        this.deleteType = type;
        indexScan({
          cursor: cursor || 0,
          precise: this.deleteType,
          searchKey: this.searchName
        }).then(data => {
          if (data && data.keyList) {
            this.dataList = data.keyList;
            this.nextCursor = data.cursor;
            this.nextTime = data.time;
          } else {
            this.dataList = [];
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .redis_manage_list{
    padding:12px;

    .header {
      padding-bottom: 10px;
      .header_right_btn{
        float:right;
        margin-left: 10px;
      }
    }
    .redis_content{
      .key_name{
        color: #409eff;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/commonTool/redisManageList.vue